const d1 = {
	fontFamily: "IRANYekanX",
	fontSize: "26.88px",
	fontWeight: "400",
	"@media (min-width:840)": {
		fontSize: "41.05px",
	},
};
const d2 = {
	fontFamily: "IRANYekanX",
	fontSize: "25.19px",
	fontWeight: "400",
	"@media (min-width:840)": {
		fontSize: "36.49px",
	},
};
const d3 = {
	fontFamily: "IRANYekanX",
	fontSize: "23.61px",
	fontWeight: "400",
	"@media (min-width:840)": {
		fontSize: "32.44px",
	},
};
const h1 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "22.13px",
	"@media (min-width:840)": {
		fontSize: "28.83px",
	},
};
const h2 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "20.74px",
	"@media (min-width:840)": {
		fontSize: "25.63px",
	},
};
const h3 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "19.44px",
	"@media (min-width:840)": {
		fontSize: "22.78px",
	},
};
const h4 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "18.22px",
	"@media (min-width:840)": {
		fontSize: "20.25px",
	},
};
const h5 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "17.07px",
	"@media (min-width:840)": {
		fontSize: "18px",
		fontWeight: "400",
	},
};

const h6 = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "16px",
	lineHeight: "30.4px",
	"@media (min-width:840)": {
		fontSize: "16px",
	},
};
const caption = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "15px",
	lineHeight: "27.02px",

	"@media (min-width:840)": {
		fontSize: "14.22px",
	},
};
const footer = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "14.05px",
	lineHeight: "24.02px",
	"@media (min-width:840)": {
		fontSize: "12.64px",
	},
};
const label = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "13.17px",
	lineHeight: "21.36px",
	"@media (min-width:840)": {
		fontSize: "11.24px",
	},
};
const warning = {
	fontFamily: "IRANYekanX",
	fontWeight: "400",
	fontSize: "12.34px",
	"@media (min-width:840)": {
		fontSize: "9.99px",
	},
};

export const projectTypography = {
	d1Regular: d1,
	d2Regular: d2,
	d3Regular: d3,
	h1Regular: h1,
	h2Regular: h2,
	h3Regular: h3,
	h4Regular: h4,
	h5Regular: h5,
	h6Regular: h6,
	captionRegular: caption,
	footerRegular: footer,
	labelRegular: label,
	warningRegular: warning,

	// 500
	d1MediumBold: {
		...d1,
		fontWeight: 500,
	},
	d2MediumBold: {
		...d2,
		fontWeight: 500,
	},
	d3MediumBold: {
		...d3,
		fontWeight: 500,
	},
	h1MediumBold: {
		...h1,
		fontWeight: 500,
	},
	h2MediumBold: {
		...h2,
		fontWeight: 500,
	},
	h3MediumBold: {
		...h3,
		fontWeight: 500,
	},
	h4MediumBold: {
		...h4,
		fontWeight: 500,
	},
	h5MediumBold: {
		...h5,
		fontWeight: 500,
	},
	h6MediumBold: {
		...h6,
		fontWeight: 500,
	},

	captionMediumBold: {
		...caption,
		fontWeight: 500,
	},
	footerMediumBold: {
		...footer,
		fontWeight: 500,
	},
	labelMediumBold: {
		...label,
		fontWeight: 500,
	},
	warningMediumBold: {
		...warning,
		fontWeight: 500,
	},

	// 600
	d1DemiBold: {
		...d1,
		fontWeight: 600,
	},
	d2DemiBold: {
		...d2,
		fontWeight: 600,
	},
	d3DemiBold: {
		...d3,
		fontWeight: 600,
	},
	h1DemiBold: {
		...h1,
		fontWeight: 600,
	},
	h2DemiBold: {
		...h2,
		fontWeight: 600,
	},
	h3DemiBold: {
		...h3,
		fontWeight: 600,
	},
	h4DemiBold: {
		...h4,
		fontWeight: 600,
	},
	h5DemiBold: {
		...h5,
		fontWeight: 600,
	},
	h6DemiBold: {
		...h6,
		fontWeight: 600,
	},

	captionDemiBold: {
		...caption,
		fontWeight: 600,
	},
	footerDemiBold: {
		...footer,
		fontWeight: 600,
	},
	labelDemiBold: {
		...label,
		fontWeight: 600,
	},
	warningDemiBold: {
		...warning,
		fontWeight: 600,
	},

	// 700
	d1Bold: {
		...d1,
		fontWeight: 700,
	},
	d2Bold: {
		...d2,
		fontWeight: 700,
	},
	d3Bold: {
		...d3,
		fontWeight: 700,
	},
	h1Bold: {
		...h1,
		fontWeight: 700,
	},
	h2Bold: {
		...h2,
		fontWeight: 700,
	},
	h3Bold: {
		...h3,
		fontWeight: 700,
	},
	h4Bold: {
		...h4,
		fontWeight: 700,
	},
	h5Bold: {
		...h5,
		fontWeight: 700,
	},
	h6Bold: {
		...h6,
		fontWeight: 700,
	},

	captionBold: {
		...caption,
		fontWeight: 700,
	},
	footerBold: {
		...footer,
		fontWeight: 700,
	},
	labelBold: {
		...label,
		fontWeight: 700,
	},
	warningBold: {
		...warning,
		fontWeight: 700,
	},

	// 800
	d1ExtraBold: {
		...d1,
		fontWeight: 800,
	},
	d2ExtraBold: {
		...d2,
		fontWeight: 800,
	},
	d3ExtraBold: {
		...d3,
		fontWeight: 800,
	},
	h1ExtraBold: {
		...h1,
		fontWeight: 800,
	},
	h2ExtraBold: {
		...h2,
		fontWeight: 800,
	},
	h3ExtraBold: {
		...h3,
		fontWeight: 800,
	},
	h4ExtraBold: {
		...h4,
		fontWeight: 800,
	},
	h5ExtraBold: {
		...h5,
		fontWeight: 800,
	},
	h6ExtraBold: {
		...h6,
		fontWeight: 800,
	},

	captionExtraBold: {
		...caption,
		fontWeight: 800,
	},
	footerExtraBold: {
		...footer,
		fontWeight: 800,
	},
	labelExtraBold: {
		...label,
		fontWeight: 800,
	},
	warningExtraBold: {
		...warning,
		fontWeight: 800,
	},

	// 900
	d1Black: {
		...d1,
		fontWeight: 900,
	},
	d2Black: {
		...d2,
		fontWeight: 900,
	},
	d3Black: {
		...d3,
		fontWeight: 900,
	},
	h1Black: {
		...h1,
		fontWeight: 900,
	},
	h2Black: {
		...h2,
		fontWeight: 900,
	},
	h3Black: {
		...h3,
		fontWeight: 900,
	},
	h4Black: {
		...h4,
		fontWeight: 900,
	},
	h5Black: {
		...h5,
		fontWeight: 900,
	},
	h6Black: {
		...h6,
		fontWeight: 900,
	},

	captionBlack: {
		...caption,
		fontWeight: 900,
	},
	footerBlack: {
		...footer,
		fontWeight: 900,
	},
	labelBlack: {
		...label,
		fontWeight: 900,
	},
	warningBlack: {
		...warning,
		fontWeight: 900,
	},
};
